import Layout from '@/components/Layout'
import Seo from '@/components/Seo'
import { whatsappLink, whatsappMessages } from '@/lib/site-data'
import {MessageCircleDashed as MessageCircle} from 'lucide-react'
import { Link } from 'react-router-dom'

function NotFound() {
  return (
    <Layout>
      <Seo
        title="Página não encontrada | Muita Mídia"
        description="A página que você procura não foi encontrada. Volte para o site da Muita Mídia e conheça como comprar uma página do Instagram com segurança."
        path="/404"
        noIndex
      />

      <section className="bg-[#0B0919]">
        <div className="mx-auto flex min-h-[60vh] max-w-xl flex-col items-center justify-center px-6 py-20 text-center">
          <span className="text-sm font-semibold text-[#C4B5FD]">Erro 404</span>
          <h1 className="mt-3 text-3xl font-bold text-white sm:text-4xl">Essa página não existe</h1>
          <p className="mt-4 text-base leading-relaxed text-zinc-400">
            O conteúdo que você procura pode ter sido movido ou não existe mais. Volte para o início ou
            fale direto com a nossa equipe pelo WhatsApp.
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center justify-center rounded-full border border-white/20 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/10"
            >
              Voltar para o início
            </Link>
            <a
              href={whatsappLink(whatsappMessages.contactCta)}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-6 py-3 text-sm font-semibold text-white transition-transform hover:scale-105"
            >
              <MessageCircle className="h-4 w-4" fill="white" strokeWidth={0} />
              Falar no WhatsApp
            </a>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default NotFound
